module.exports = __webpack_public_path__ + "img/VEG2.89bb6798.png";